<template>
    <!-- Page header -->
    <div>
        <div class="page-header page-header-light">
            <div class="page-header-content header-elements-md-inline">
                <div class="page-title d-flex">
                    <h4><span class="font-weight-semibold">Events per domain and account for last {{ timeWindow
}} hours, showing entries with more than {{ countThreshold }} sent messages. The limit for
                            blocking domain+account pair is {{ rateLimit * 100 }}% (Deferred/Sent %)</span></h4>
                </div>
            </div>
        </div>
        <!-- /page header -->
        <!-- Content area -->
        <div class="content">
            <div class="card">
                <div class="table-responsive" :class="{ 'loading-mask': loading }">
                    <button @click="load" class="btn btn-primary pull-right" style="margin: 10px">Refresh list</button>

                    <table class="table table-striped table-xs" style="min-height: 100px">
                        <thead>
                            <tr>
                                <th>No.</th>
                                <th>Domain</th>
                                <th>Account</th>
                                <th>Sent</th>
                                <th>Delivered</th>
                                <th>Suppressed</th>
                                <th>Deferred</th>
                                <th>Deferred/Sent %</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="r, k in rows">
                                <td style="width:10px">{{ k + 1 }}</td>

                                <td>{{ r._id.domain }}</td>
                                <td>{{ r.account[0].name }} ({{ r.account[0].provider }})</td>
                                <td>{{ r.sent }}</td>
                                <td>{{ r.delivered }}</td>
                                <td>{{ r.suppressed }}</td>
                                <td>{{ r.deferred }}</td>
                                <td>{{ Math.round(10000 * (r.deferred / r.sent)) / 100
}}%
                                </td>
                                <td>
                                    <button v-if="!getBlocked(r._id.domain, r.account[0]._id)" class="btn btn-danger"
                                        v-tooltip="'Will add domain as blocked for 24 hours'"
                                        @click="block(r._id.domain, r.account[0]._id)">Block</button>
                                    <span v-else class="badge badge-warning">Blocked, expires at: {{
        getBlocked(r._id.domain,
            r.account[0]._id).expire_at | formatDate
}}</span>
                                </td>
                            </tr>
                            <h2 v-if="rows.length === 0"> </h2>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <!-- /content area -->

        <!-- /content area -->
    </div>
</template>
<script>
let queryDebounce
import moment from 'moment'
import EventBus from '@/event_bus'
export default {
    data() {
        return {

            rows: [],
            blocked: [],
            loading: true,
            adding: false,
            timeWindow: 0,
            countThreshold: 0,
            rateLimit: 0
        }
    },
    watch: {
        '$route.params.type'() {
            this.load()
        },
    },
    computed: {
        type() {
            return this.$route.params.type
        },
    },
    methods: {
        downloadCsv() {
            this.$confirm({ message: 'Confirm CSV export' }).then(() => {

                let u = this.$api.getUrl() + 'suppression_list/' + this.$route.params.type + '/download/csv'

                window.open(u)
                this.$notify.addWarning('Generating CSV please wait...')
            })
        },
        getBlocked(domain, accountId) {
            return this.blockedDomains.filter(e => e.domain === domain && e.account === accountId).pop()
        },
        block(domain, accountId) {
            this.$confirm({ message: 'Confirm domain block: ' + domain }).then(() => {
                this.loading = true
                this.$api.postReq(`suppression_list/block/domain`, {
                    domain: domain,
                    account_id: accountId
                }).then(res => {
                    this.load()
                    this.$notify.addSuccess('domain blocked')
                })
            })
        },
        prevPage() {
            this.offset -= 25
            this.load()
        },
        nextPage() {
            this.offset += 25
            this.load()
        },
        load() {
            this.loading = true
            this.$api.getReq(`account_stats`, {
            }).then(res => {
                this.rows = res.body.data
                this.loading = false
                this.timeWindow = res.body.time_window
                this.countThreshold = res.body.count_threshold
                this.rateLimit = res.body.rate_limit
                this.blockedDomains = res.body.blocked
            })
        }
    },
    destroyed() { },
    mounted() {
        this.load()
    }
}
</script>
<style>
tbody .btn {
    padding: 3px 11px;
}
</style>


// WEBPACK FOOTER //
// src/components/AccountStats.vue